// extracted by mini-css-extract-plugin
export default {"degreeTitle":"ShowDegree_degreeTitle__jKcB+","header":"ShowDegree_header__lxLJ5","itemBtn":"ShowDegree_itemBtn__Z4C2+","optionsContainer":"ShowDegree_optionsContainer__Eu-M6"};